"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappedComponent = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TimelineActions = _interopRequireDefault(require("crm_ui/timeline/data/actions/TimelineActions"));

var _TimelineDateRangeDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineDateRangeDependency"));

var _TimelineOverridableFavoriteEventsDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineOverridableFavoriteEventsDependency"));

var _TimelineStatusDependency = _interopRequireDefault(require("crm_ui/timeline/data/dependencies/TimelineStatusDependency"));

var _TimelineFilterHelpers = _interopRequireDefault(require("crm_ui/timeline/helpers/TimelineFilterHelpers"));

var _loggers = require("customer-data-tracking/loggers");

var _generalStore = require("general-store");

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _UIFlex2 = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _SubjectContext = require("crm_ui/profile/SubjectContext");

var _TimelineAdvancedFilters = _interopRequireDefault(require("../filter/TimelineAdvancedFilters"));

var _TimelineEventsFilter = _interopRequireDefault(require("../filter/TimelineEventsFilter"));

var _TimelineSearchTextInput = _interopRequireDefault(require("../filter/TimelineSearchTextInput"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var UIFlex = (0, _styledComponents.default)(_UIFlex2.default).withConfig({
  displayName: "TimelineFilters__UIFlex",
  componentId: "gp33lk-0"
})(_templateObject());

var TimelineFilters =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(TimelineFilters, _React$Component);

  function TimelineFilters(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineFilters);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineFilters).call(this, props));

    _this.handleOpenChange = function (_ref) {
      var value = _ref.target.value;

      _this.setState({
        isFilterOpen: value
      });
    };

    _this.handlePopoverToggle = function () {
      _this.setState({
        isFilterOpen: !_this.state.isFilterOpen
      });
    };

    _this.handleUpdateTimelineFavoritedEvents = function (eventOptions) {
      var _this$props = _this.props,
          dateRange = _this$props.dateRange,
          searchText = _this$props.searchText;
      var _this$context = _this.context,
          objectType = _this$context.objectType,
          subjectId = _this$context.subjectId;
      var requestPayload = (0, _immutable.Map)({
        eventOptions: eventOptions,
        fromDate: dateRange.get('fromDate'),
        now: dateRange.get('now'),
        objectType: objectType,
        subjectId: subjectId,
        selectedTeams: _this.props.selectedTeams,
        selectedUsers: _this.props.selectedUsers,
        searchText: searchText
      });

      _TimelineActions.default.updateTimelineFavoritedEvents(objectType, eventOptions, requestPayload);
    };

    _this.handleFilterTimelineByText = function (searchText) {
      var _this$props2 = _this.props,
          dateRange = _this$props2.dateRange,
          timelineFavoriteEvents = _this$props2.timelineFavoriteEvents;
      var _this$context2 = _this.context,
          objectType = _this$context2.objectType,
          subjectId = _this$context2.subjectId;
      var requestPayload = (0, _immutable.Map)({
        eventOptions: timelineFavoriteEvents,
        fromDate: dateRange.get('fromDate'),
        now: dateRange.get('now'),
        objectType: objectType,
        subjectId: subjectId,
        selectedTeams: _this.props.selectedTeams,
        selectedUsers: _this.props.selectedUsers,
        searchText: searchText
      });

      _loggers.CrmLogger.logRecordInteraction(objectType, {
        action: 'filter timeline by text',
        subAction: searchText
      });

      _TimelineActions.default.updateTimelineUserAndTeamFilters(objectType, timelineFavoriteEvents, requestPayload);
    };

    _this.handleFilterTimelineByText = (0, _debounce.default)(250, _this.handleFilterTimelineByText);
    _this.handleResetFilters = _this.handleResetFilters.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isFilterOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(TimelineFilters, [{
    key: "handleResetFilters",
    value: function handleResetFilters() {
      _TimelineFilterHelpers.default.handleResetFilters(this.context.objectType);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          dateRange = _this$props3.dateRange,
          hasEvents = _this$props3.hasEvents,
          activityTabIsSelected = _this$props3.activityTabIsSelected,
          timelineStatus = _this$props3.timelineStatus,
          timelineFavoriteEvents = _this$props3.timelineFavoriteEvents;
      var _this$context3 = this.context,
          objectType = _this$context3.objectType,
          subjectId = _this$context3.subjectId;

      if (!activityTabIsSelected || !timelineFavoriteEvents) {
        return null;
      }

      var availableOptions = _TimelineFilterHelpers.default.getAvailableOptions(objectType);

      var availableOptionsList = availableOptions.reduce(function (list, options) {
        return list.concat(options);
      }, (0, _immutable.List)());
      var integrationsApps = timelineStatus.get('integrationsApps');
      var className = (0, _classnames.default)('width-100 flex-row align-start p-top-0', {
        'p-bottom-4': !hasEvents
      });
      return _react.default.createElement("div", {
        "data-reagan-success": "timeline",
        "data-selenium-test": "timeline-filter-container"
      }, _react.default.createElement(UIFlex, {
        key: "filters",
        className: className
      }, _react.default.createElement(_UIList.default, {
        inline: true
      }, _react.default.createElement(_TimelineEventsFilter.default, {
        availableOptions: availableOptions,
        availableOptionsList: availableOptionsList,
        handleOpenChange: this.handleOpenChange,
        handlePopoverToggle: this.handlePopoverToggle,
        handleUpdateTimelineFavoritedEvents: this.handleUpdateTimelineFavoritedEvents,
        integrationsApps: integrationsApps,
        isOpen: this.state.isFilterOpen,
        objectType: objectType,
        timelineFavoriteEvents: timelineFavoriteEvents
      }), _react.default.createElement(_TimelineAdvancedFilters.default, {
        dateRange: dateRange,
        objectType: objectType,
        onResetFilters: this.handleResetFilters,
        subjectId: subjectId,
        timelineFavoriteEvents: timelineFavoriteEvents
      })), _react.default.createElement(_TimelineSearchTextInput.default, {
        onChange: this.handleFilterTimelineByText,
        objectType: objectType
      })));
    }
  }]);
  return TimelineFilters;
}(_react.default.Component);

exports.WrappedComponent = TimelineFilters;
TimelineFilters.contextType = _SubjectContext.SubjectContext;
TimelineFilters.propTypes = {
  activityTabIsSelected: _propTypes.default.bool.isRequired,
  dateRange: _reactImmutableProptypes.default.contains({
    fromDate: _propTypes.default.number,
    now: _propTypes.default.number,
    toDate: _propTypes.default.number
  }),
  hasEvents: _propTypes.default.bool.isRequired,
  searchText: _propTypes.default.string,
  selectedTeams: _reactImmutableProptypes.default.list,
  selectedUsers: _reactImmutableProptypes.default.list,
  timelineFavoriteEvents: _propTypes.default.instanceOf(_immutable.List),
  timelineStatus: _propTypes.default.instanceOf(_immutable.Map)
};

var _default = (0, _generalStore.connect)({
  dateRange: _TimelineDateRangeDependency.default,
  timelineFavoriteEvents: _TimelineOverridableFavoriteEventsDependency.default,
  timelineStatus: _TimelineStatusDependency.default
})(TimelineFilters);

exports.default = _default;